export default [
  {
    path: 'type',
    meta: {
      title: 'EventTypes',
      auth: ['Admin', 'Super Admin'],
      hidden: false
    },
    component: () => import('./pages/index'),
    redirect: 'type/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'eventType',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'eventType',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'eventType',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      }
    ]
  }
]
